import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../../../../../../src/components/common/blur-modal';
import Button from '@dbk/ui-buttons';
import {StyleSheet} from 'react-native';
import Text from '@dbk/ui-text';

class IsNonActivePortfolio extends PureComponent {

    componentDidUpdate(){
        if(document.querySelector('.inactive-portfolio-focus')){
            document.querySelector('.inactive-portfolio-focus').focus();
          }
    }

    constructor(props) {
        super(props);
    }
    closeMsg = () => {
        this.props.auth.setFalse(false)
    }

    render() {
        const { auth: { isNonActivePortfolio, dashboardAuthorised }, i18n: { messages } } = this.props;
        return (
            <BlurModal
                visible={isNonActivePortfolio && dashboardAuthorised}
                doneVisible={true}
                title={messages['app.common.copyrightText']}
                onDone={() => this.closeMsg()}
                className = "model-window-login"
            >
                <Text className="pad-left-10 model-detail-text inactive-portfolio-focus" tabIndex={0}>
                {messages['app.auth.portfolio.nonActiveMsg']}
                </Text>
                
                <div className="row">
                    <div className="large-6 large-centered medium-6 medium-centered small-6 small-centered pad-top-20 text-center">
                        <Button size={'large'} onClick={() => this.closeMsg()} >
                             {messages['app.rmcallback.okMsg']}
                       </Button>
                    </div>
                </div>
            </BlurModal >
        );
    }
}

export default createContainer({
    $queries: {
        auth: {
            isNonActivePortfolio: true,
            setFalse: { $set: 'isNonActivePortfolio' },
            dashboardAuthorised: true,
        },
        i18n: {
            messages: true,
        }
    }
})(IsNonActivePortfolio);
